import { Link } from 'react-router-dom';

import { IconWarningStrong } from '@flixbus/honeycomb-icons-react';

import { LABELS } from '../labels';

import styles from '../styles.module.css';

const DriverInfo = ({ crewMember, driverName, driverId, isProblematic, hasBreakdown }) => {
	if (isProblematic) {
		return (
			<>
				<div className={styles.notAssigned}>{LABELS.notAssigned}</div>
				{crewMember && (
					<div className={styles.previouslyAssigned}>
						{LABELS.previouslyAssigned}
						<br />
						{LABELS.to}{' '}
						<Link className={styles.prevAssignedLink} to={`/crew-management/${crewMember.id}`}>
							{crewMember.fullName}
						</Link>
					</div>
				)}
			</>
		);
	}

	const content = (
		<>
			<div className={styles.driverName}>
				{hasBreakdown && <IconWarningStrong data-testid="breakdown-icon" width={24} height={24} />}
				<span>{driverName}</span>
			</div>
			<div className={styles.driverIdLabel}>
				{LABELS.driverIdPrefix} <span>{driverId}</span>
				{LABELS.driverIdSuffix}
			</div>
		</>
	);

	if (crewMember) {
		return (
			<Link className={styles.driverLink} to={`/crew-management/${crewMember.id}`}>
				{content}
			</Link>
		);
	}

	return <div className={styles.driverLink}>{content}</div>;
};

export default DriverInfo;
